import { notification_color_keys, useNotifications } from "utils/hooks";
import { useCustomMutation } from "data/modules/api/hooks/useCustomMutation";
import useCustomQueryClient from "data/modules/api/hooks/useQueryClient";
import { SOMETHING_WENT_WRONG } from "constants/displayStrings";
import { DELETE_CUSTOM_COLUMN } from "../constants/CustomColumns.api";
import { getCustomColumnQueryKey } from "./customColumnQueryKeys";

export const useDeleteCustomColumn = ({ sectionName }) => {
  const queryClient = useCustomQueryClient();
  const { notify } = useNotifications();

  return useCustomMutation({
    url: DELETE_CUSTOM_COLUMN,
    onSuccess: () => {
      notify("Column Deleted Successfully!", notification_color_keys.success);
      queryClient.invalidateQueries({
        queryKey: getCustomColumnQueryKey({ section_name: sectionName }),
      });
    },
    onError: (err) => {
      notify(
        err?.response?.data?.message || SOMETHING_WENT_WRONG,
        notification_color_keys.error
      );
    },
  });
};
